import { useEffect, useState } from 'react';

const BASE_FONT_SIZE = 16;
const BASE_FONT_RATIO = 0.05;

export function useFontSize(
  seedSize = BASE_FONT_SIZE,
  seedRatio = BASE_FONT_RATIO
) {
  const [fontSize, setFontSize] = useState(
    typeof window === 'object'
      ? Math.min(
          Math.min(window.innerWidth, window.innerHeight) === window.innerHeight
            ? seedRatio * window.innerHeight
            : seedRatio * window.innerWidth,
          seedSize
        )
      : 16
  );

  useEffect(() => {
    if (!(typeof window === 'object')) return () => null;

    function handleResize() {
      const screenFont =
        Math.min(window.innerWidth, window.innerHeight) === window.innerHeight
          ? seedRatio * window.innerHeight
          : seedRatio * window.innerWidth;
      setFontSize(Math.min(screenFont, seedSize));
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [seedRatio, seedSize]);
  return fontSize;
}
